<template>
  <div class="file-preview-page">
    <iframe class="preview-box" :src="previewUrl" frameborder="0" @load="hideLoading"></iframe>
  </div>
</template>

<script>
export default {
	name: 'filePreview',
	data() {
		return {
			previewUrl: decodeURIComponent(this.$route.query.previewurl),
			previewLoading: null
		}
	},
	created() {
		console.log(this.previewUrl)
	},
	mounted() {
		this.previewLoading = this.$toast.loading({
			duration: 0, // 持续展示 toast
			forbidClick: true
		})
	},
	methods: {
		hideLoading() {
			// 延迟一下隐藏loading，因为有时候预览内容还没渲染完成
			setTimeout(() => {
				this.previewLoading.clear()
			}, 1000)
		}
	}
}
</script>

<style lang="scss" scoped>
.file-preview-page {
	text-align: left;
	height: 100%;
	.preview-box {
		width: 100%;
		height: 100%;
	}
}
</style>
